"use strict";

exports.__esModule = true;
exports.ClassificationSelectorIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PlantStateActivities = require("../../PlantStateActivities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * @component
 */

var ClassificationSelectorIcon = exports.ClassificationSelectorIcon = _styledComponents["default"].div.withConfig({
  displayName: "ClassificationSelectorIcon",
  componentId: "sc-12bc4y3-0"
})(["box-sizing:border-box;width:20px;height:20px;background:", ";"], function (_ref) {
  var state = _ref.state,
    theme = _ref.theme;
  return (0, _PlantStateActivities.getPlantStateColor)(theme, state.id);
});